export enum Designator {
  Period = 'P',
  Time = 'T',
}
